import type CustomsDeclaration from '~/types/CustomsDeclaration';

import { USPS } from '~/constants/carriers';
import {
  requiresCustomsDeclaration,
  type CustomsValidationAddress,
} from '~/types/CustomsDeclaration';

import { EEL_PFC_OPTION, OPTIONS } from '../constants/eelPfc.const';
import {
  type EELPFCDecision,
  type EELPFCOption,
  type EELPFCValidation,
} from '../types/eelPfc.type';

export const getEELPFCOptionLabelByValue = (value: EELPFCOption): JSX.Element | string => {
  const idx = OPTIONS.findIndex((o) => o.value === value);
  if (idx > -1) return OPTIONS[idx].label;

  return 'NA';
};

export const defaultFormValues = (
  defaultValues?: CustomsDeclaration,
  eelPfcDecision?: EELPFCDecision,
) => ({
  aesItn: defaultValues?.aesItn || eelPfcDecision?.aesItn || '',
  eelPfc: defaultValues?.eelPfc || eelPfcDecision?.eelPfc || EEL_PFC_OPTION.AESITN,
});

export const isEELPFCValid = (customsDeclaration?: EELPFCValidation | null) => {
  if (!customsDeclaration) return false;

  const aesItn = customsDeclaration.aesItn ?? customsDeclaration.aes_itn;
  const eelPfc = customsDeclaration.eelPfc ?? customsDeclaration.eel_pfc;

  if (!eelPfc) return false;
  if (eelPfc === EEL_PFC_OPTION.AESITN)
    return !!aesItn && !!aesItn.length && !!aesItn.match(/(x|X)\d{14}/);

  if (OPTIONS.map((o) => o.value).includes(eelPfc as EELPFCOption)) return true;

  return false;
};

export const isEELPFCRequiredForOrderShipmentAndRate = (
  orderShipment?: {
    addressFrom?: CustomsValidationAddress | null;
    addressTo?: CustomsValidationAddress | null;
    customsDeclaration?: EELPFCValidation | null;
  },
  selectedRateProvider?: string,
  aesItnFlag?: boolean,
) => {
  if (!orderShipment || !selectedRateProvider || !aesItnFlag) return false;
  if (!orderShipment.addressFrom || !orderShipment.addressTo) return false;
  if (!requiresCustomsDeclaration(orderShipment.addressFrom, orderShipment.addressTo)) return false;
  if (selectedRateProvider !== USPS.name) return false;
  if (isEELPFCValid(orderShipment.customsDeclaration)) return false;
  return true;
};
